import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';

import {
  ContactPopup,
  Loader,
  Sidebar,
  Toast,
  deserify,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { interactionEvent } from '../../pages/Auth/Login/login_logout.events';
import {
  setContactPopupOpen,
  setShowNameEditPopup,
} from '../../pages/Auth/reducer/auth.slice';
import { useAppSelector } from '../../reduxStore/reduxHooks';
import { useSideBarOptions } from '../../utils/sidebarOptions';
import Header from '../Header';
import { setToastInfo } from '../../pages/Home/reducer/homeDashboard.slice';
import { useDownloadContext } from '../../app/Context/DownloadContextProviderV2';
import StudentNameEditPopup from '../../pages/Home/components/StudentNameEditPopup';
import { PAL_KNOWLEDGE_CONCEPTS } from '../../routeHandling/RoutesNomenclature';

interface AppLayoutProps {
  hideHeader?: boolean;
}

export const AppLayout: React.FC<AppLayoutProps> = (props) => {
  const { hideHeader } = props;
  const location = useLocation();
  const headerIgnorePaths = [PAL_KNOWLEDGE_CONCEPTS];
  const doNotRenderHeader =
    hideHeader ||
    headerIgnorePaths.some((path) => location.pathname.includes(path));
  const pathSegments = location.pathname.split('/');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarDisplay, setSidebarDisplay] = useState(false);
  const options = useSideBarOptions();
  const { contactPopupOpen, userInfo, isLoggingOut, showNameEditPopup } =
    deserify(useAppSelector((state) => state.auth));
  const { toast_info } = deserify(useAppSelector((state) => state.home));
  const { isOffline } = useDownloadContext();
  const dispatch = useDispatch();
  const closeToastHandler = () => {
    dispatch(setToastInfo({ label: '', variant: 'success', open: false }));
  };

  return (
    <>
      {isLoggingOut && <Loader />}
      <Toast
        variant={toast_info?.variant}
        open={toast_info?.open}
        label={toast_info?.label}
        onClose={closeToastHandler}
      />
      {isMobile && (
        <Sidebar
          open={sidebarDisplay}
          handleClose={() => setSidebarDisplay(false)}
          options={options}
        />
      )}
      {!doNotRenderHeader && (
        <Header
          sidebarDisplay={sidebarDisplay}
          setSidebarDisplay={setSidebarDisplay}
        />
      )}
      {showNameEditPopup && (
        <StudentNameEditPopup
          open={showNameEditPopup}
          onClose={() => {
            dispatch(setShowNameEditPopup(false));
          }}
          studentProfile={userInfo}
        />
      )}
      <ContactPopup
        open={contactPopupOpen}
        setOpen={async (val: boolean) => {
          dispatch(setContactPopupOpen(val));
          await interactionEvent({
            url: '',
            context: 'contact',
            name: 'contact_us_popup_close',
            pathSegments: pathSegments,
            isOffline: isOffline,
          });
        }}
        schoolId={userInfo?.schoolDetails?.schoolId}
      />
      {/* {!hideHeader && <Header />} */}
      <Box
        sx={
          doNotRenderHeader
            ? {
                height: '100%',
              }
            : {
                paddingTop: { xs: pxToRem(60), md: pxTovW(100) },
                height: {
                  xs: `calc(100% - ${pxToRem(60)})`,
                  md: `calc(100% - ${pxTovW(100)})`,
                },
              }
        }
      >
        <Outlet />
        <ScrollRestoration />
      </Box>
    </>
  );
};

export default AppLayout;
